import { Button } from "@shared/components/ui/Button";
import theme from "@shared/utils/themeColors";

interface SpaceLeftContentProps {
  onCreateSpace: () => void;
}

function SpaceLeftContent({ onCreateSpace }: SpaceLeftContentProps) {
  return (
    <div className="w-full md:w-60 mb-8 md:mb-0">
      <div className="md:sticky md:top-16 md:h-[calc(100dvh-64px)] md:overflow-x-hidden md:overflow-y-auto no-scrollbar">
        <div className="md:py-8">
          <div className="flex justify-between items-center md:block">
            {/* Title */}
            <header className="mb-6">
              <h1 className={`text-2xl md:text-3xl ${theme.text.primary}`}>
                Spaces
              </h1>
            </header>

            {/* Button */}
            <div className="xl:hidden mb-6">
              <Button variant="primary" fullWidth onClick={onCreateSpace}>
                Create Space
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpaceLeftContent;
